export const certTypes = [
    {
        description: 'certTypes.idCard',
        label: 'certTypes.idCard',
        type: 'certTypes',
        value: '1'
    },
    {
        description: 'certTypes.passport',
        label: 'certTypes.passport',
        type: 'certTypes',
        value: '2'
    },
    {
        description: 'certTypes.driverLicense',
        label: 'certTypes.driverLicense',
        type: 'certTypes',
        value: '3'
    },
    {
        description: 'certTypes.householdBook',
        label: 'certTypes.householdBook',
        type: 'certTypes',
        value: '4'
    },
    {
        description: 'certTypes.residencePermit',
        label: 'certTypes.residencePermit',
        type: 'certTypes',
        value: '5'
    }
];

export default certTypes;